/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

export type ComplementInseePartenaire = {
  etatMatrimonialCode?: string | null;
  dateDivorce?: string | null;
  dateVeuvage?: string | null;
  dejaPacse?: string | boolean | null;
  nombreEnfants?: number | null;
};

export const NOMBRE_ENFANTS_MAX = 20;

// Plafond du nombre d'enfants en commun : contrôlé à la saisie et à
// l'enregistrement, y compris sur un projet de PACS (où le reste du complément
// INSEE n'est pas obligatoire). Retourne le message d'erreur, ou null.
export const validationNombreEnfantsMax = (
  nombreEnfants: number | null | undefined,
): string | null =>
  !_.isNil(nombreEnfants) && nombreEnfants > NOMBRE_ENFANTS_MAX
    ? `Le nombre maximal d'enfants communs est ${NOMBRE_ENFANTS_MAX}`
    : null;

// Informations INSEE d'un partenaire : obligatoires sauf pour un projet de PACS
// (contrôle à la charge de l'appelant). Le nombre d'enfants en commun n'est
// saisi que sur le partenaire 1.
const validationComplementInsee = (
  complementInsee: ComplementInseePartenaire,
  avecNombreEnfants: boolean,
) => {
  const {
    etatMatrimonialCode,
    dateDivorce,
    dateVeuvage,
    dejaPacse,
    nombreEnfants,
  } = complementInsee ?? {};

  const errors = {
    etatMatrimonial: '',
    dateEtatMatrimonial: '',
    dejaPacse: '',
    nombreEnfants: '',
  };

  if (_.isEmpty(etatMatrimonialCode)) {
    errors.etatMatrimonial = "L'état matrimonial antérieur est obligatoire";
  }

  if (etatMatrimonialCode === 'D' && _.isEmpty(dateDivorce)) {
    errors.dateEtatMatrimonial = 'La date du divorce est obligatoire';
  }

  if (etatMatrimonialCode === 'V' && _.isEmpty(dateVeuvage)) {
    errors.dateEtatMatrimonial = 'La date du veuvage est obligatoire';
  }

  if (_.isNil(dejaPacse) || dejaPacse === '') {
    errors.dejaPacse = 'Il faut indiquer si le partenaire a déjà été pacsé';
  }

  if (avecNombreEnfants && _.isNil(nombreEnfants)) {
    errors.nombreEnfants = "Le nombre d'enfants en commun est obligatoire";
  } else if (avecNombreEnfants) {
    errors.nombreEnfants = validationNombreEnfantsMax(nombreEnfants) ?? '';
  }

  return _.pickBy(errors, (value) => value !== '');
};

export default validationComplementInsee;
